module.exports = __webpack_public_path__ + "static/media/test11_3.96ddfe19.png";